import * as types from './constants'

const initialState = {
	externalReports: [],
	allExternalReports: [],
	searchValue: '',
	searchValueOnClick: '',
	externalReportsLoaded: false,
	overlayIsShowing: false,
	storeName: '',
	editOverlayIsShowing: false,
	currentExternalReport: null,
	status: true,
	items: [],
	pageOfItems: [],
	selectedExternalReports: [],
	userExternalReports: [],
}

const externalReportsReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_EXTERNAL_REPORTS:
			return {
				...state,
				externalReports: action.externalReports,
			}
		case types.SET_ALL_EXTERNAL_REPORTS:
			return {
				...state,
				allExternalReports: action.stores,
			}
		case types.SET_SEARCH_VALUE:
			return {
				...state,
				searchValue: action.searchValue,
			}
		case types.SET_SERACH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.SET_EXTERNAL_REPORTS_LOADED:
			return {
				...state,
				externalReportsLoaded: action.value,
			}
		case types.TOGGLE_OVERLAY:
			return {
				...state,
				overlayIsShowing: !state.overlayIsShowing,
			}
		case types.TOGGLE_EDIT_OVERLAY:
			return {
				...state,
				editOverlayIsShowing: !state.editOverlayIsShowing,
			}
		case types.SET_EXTERNAL_REPORT_NAME:
			console.log('action.value in exrp', action.value)
			return {
				...state,
				externalReportName: action.value,
			}
		case types.SET_EXTERNAL_REPORT_ID:
			return {
				...state,
				externalReportId: action.value,
			}
		case types.SELECT_EXTERNAL_REPORT:
			return {
				...state,
				selectedExternalReports: action.payload,
			}
		case types.SET_CURRENT_EXTERNAL_REPORT:
			return {
				...state,
				currentExternalReport: action.value,
			}
		case types.SET_CURRENT_EXTERNAL_REPORT_NAME:
			return {
				...state,
				currentExternalReport: {
					...state.currentExternalReport,
					name: action.value,
				},
			}
		case types.SET_CURRENT_EXTERNAL_REPORT_ID:
			return {
				...state,
				currentExternalReport: {
					...state.currentStore,
					location_id: action.value,
				},
			}
		case types.TOGGLE_CURRENT_STATUS:
			return {
				...state,
				currentExternalReport: {
					...state.currentStore,
					status: state.currentStore && !state.currentStore.status,
				},
			}
		case types.SET_ITEMS:
			return {
				...state,
				items: action.items,
			}
		case types.SET_PAGE_OF_ITEMS:
			return {
				...state,
				pageOfItems: action.pageOfItems,
			}
		case types.SET_USER_EXTERNAL_REPORTS:
			return {
				...state,
				userExternalReports: action.payload,
			}
		default:
			return state
	}
}

export default externalReportsReducer
